import { useContext } from 'react';
import { AuthContext } from '../../../services/authContext';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-8685c875a9/icons';
import routes from '../../../routes';

const UserDashTiles = () => {
    const { userProfile, userRoles } = useContext(AuthContext);

    const hasAccess = (routeRoles) => {
        if (!routeRoles || routeRoles.length === 0) return true;
        return routeRoles.some(role => userRoles.includes(role));
    };

    return (
        <Row>
            <Col xs={12} className="p-0">
                <Row className="justify-content-center">
                    {routes
                        .filter(route => !route.hidden && !route.hiddenOnDash)
                        .map(({ path, name, icon, roles }) => {
                            const access = hasAccess(roles);
                            return (
                                <Col key={path} xs={12} md={6} lg={3}>
                                    <div className="userDashTiles component">
                                        <Row className="mb-0">
                                            <Col xs={12} className="text-center">
                                                <Link to={path}>
                                                    <FontAwesomeIcon icon={byPrefixAndName.fas[icon]} />
                                                    <br />
                                                    {name}
                                                </Link>
                                                <div style={{ fontSize: '0.9rem', marginTop: '0.25rem' }}>
                                                    {access ? (
                                                        <span className="text-success">(Access Granted)</span>
                                                    ) : (
                                                        <span className="text-danger">(No Access)</span>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            );
                        })}
                </Row>
            </Col>
        </Row>
    );
};

export default UserDashTiles;
